import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { TitleTextField } from '../atomic-components/TitleTextfield';
import { PropertySellingPointsTextField } from '../atomic-components/PropertySellingPointsTextField';
import { PropertyHighlightTextField } from '../atomic-components/PropertyHighlightTextField';
import { PropertyDetailsTextField } from '../atomic-components/PropertyDetailsTextField';
import { LocationDetailsTextField } from '../atomic-components/LocationDetailsTextField';
import { DistrictDetailsTextField } from '../atomic-components/DistrictDetailsTextField';
import { CityDetailsTextField } from '../atomic-components/CityDetailsTextField';
import { RentalDetailsTextField } from '../atomic-components/RentalDetailsTextField';
import { FloorplanDescriptionTextField } from '../atomic-components/FloorplanDescriptionTextField';
import { InvestmentDetailsTextField } from '../atomic-components/InvestmentDetailsTextField';
import { SecurityDetailsTextField } from '../atomic-components/SecurityDetailsTextField';
import { InvestmentDetailsAdditionTextField } from '../atomic-components/InvestmentDetailsAdditionTextField';
import { AssetTypeConditional } from '../../user/AssetTypeConditional';

export const AssetApprovalDescriptions = () => {
  return (
    <LaunchpadCard title={'Descriptions'}>
      <TitleTextField />
      <PropertySellingPointsTextField />
      <PropertyHighlightTextField />
      <PropertyDetailsTextField />
      <LocationDetailsTextField />
      <DistrictDetailsTextField />
      <CityDetailsTextField />
      <RentalDetailsTextField />
      <FloorplanDescriptionTextField />
      <InvestmentDetailsTextField />
      <AssetTypeConditional supported={['builderOwnerModel']}>
        <InvestmentDetailsAdditionTextField />
      </AssetTypeConditional>
      <SecurityDetailsTextField />
    </LaunchpadCard>
  );
};
